import { render } from "./FeaturedArticles.vue?vue&type=template&id=d79257de"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js"

import "./FeaturedArticles.vue?vue&type=style&index=0&id=d79257de&lang=css"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__